// Same-origin axios client. Uses window.location.origin per project rule.
import axios from "axios";

const BACKEND_URL =
    (typeof window !== "undefined" && window.location.origin) || "";

if (typeof window !== "undefined") {
    // eslint-disable-next-line no-console
    console.log("[API] BACKEND_URL =", BACKEND_URL);
}

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
    timeout: 20000,
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            // Soft signal — pages will react via auth store
            if (typeof window !== "undefined") {
                window.dispatchEvent(new CustomEvent("auth:unauthorized"));
            }
        }
        return Promise.reject(err);
    },
);

export const formatApiError = (err) => {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Bilinmeyen hata";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    }
    return String(detail);
};

export default api;
